export const API_URL = "https://campusbackend.bns.co.kr"; 

// export const API_URL = ""; // test DB 연결을 위한 코드
